import React from "react";
import { MARQUEE_ITEMS } from "../lib/content";

export const Marquee = ({ dark = false }) => {
  const items = [...MARQUEE_ITEMS, ...MARQUEE_ITEMS];
  return (
    <div
      className={`relative overflow-hidden py-5 border-y ${
        dark ? "bg-teal-900 border-teal-800" : "bg-teal-700 border-teal-600"
      }`}
      data-testid="editorial-marquee"
    >
      <div className="flex w-max animate-marquee whitespace-nowrap">
        {items.map((it, i) => (
          <span key={i} className="flex items-center">
            <span className="font-serif italic text-2xl sm:text-3xl text-white px-6">{it}</span>
            <span className="h-2 w-2 rounded-full bg-coral" />
          </span>
        ))}
      </div>
    </div>
  );
};
